module.exports = function(data) {
var __t, __p = '';
__p += '<div class="category-header">\n    <i class="fal fa-plus-square toggle-indicator" aria-hidden="true"></i>\n    <div class="alias">' +
((__t = ( data.alias )) == null ? '' : __t) +
'</div>\n</div>\n<div class="category-items"></div>';
return __p
}